import React, { useEffect, useMemo, useState } from 'react';
import { Box, Drawer, List, ListItem, Typography, Divider, Button, Avatar, FormControlLabel, Checkbox, TextField, Modal, Fade, Backdrop, Slide, Slider, Select, MenuItem, FormControl, InputLabel, CircularProgress, Pagination } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LeadListFilters from './LeadListFilters';
import debounce from 'lodash/debounce';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Chip } from '@mui/material';
import { locationsOptions } from '../utilities/constants';



function HomeTable() {
  const location = useLocation();

  const [showFilters, setShowFilters] = useState(true);       // show/hide drawer
  const [filtersExpanded, setFiltersExpanded] = useState(false); // narrow vs wide drawer
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [totalRowCount, setTotalRowCount] = useState(null)
  const [totalStates, setTotalStates] = useState([]);
  const [totalIndustries, setTotalIndustries] = useState([]);
  const [unlockedLeads, setUnlockedLeads] = useState([]);

  const [checkedRows, setCheckedRows] = useState({});
  const [numberOfTokens, setNumberOfTokens] = useState(0);
  const [successUnlockModal, setSuccessUnlockModal] = useState(false);
  const [failedUnlockModal, setFailedUnlockModal] = useState(false);



  const handleCheck = (id) => {
    setCheckedRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the checked state
    }));
  };

  const fetchIndustries = async () => {
    try {
      const response = await axios.get('https://api.pathvizor.com/industries'); // Replace with your API endpoint
      const responseArray = []
      response.data.forEach((industry) => {
          responseArray.push(
              industry.name
          )})

      setTotalIndustries(responseArray)
    } catch (err) {
      console.log('Failed to fetch industries. Please try again later.');
    } 
  };

  const fetchUnlockedLeads = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get('https://api.pathvizor.com/unlocked_leads', config); // Replace with your API endpoint
      const unlockedLeads = []
      response.data.forEach((lead) => {
        unlockedLeads.push(lead.lead_id)
      })
      setUnlockedLeads(unlockedLeads);
    } catch (err) {
      console.log('Failed to fetch unlocked leads. Please try again later.');
    }
  };

  const fetchNumberOfTokens = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get('https://api.pathvizor.com/tokens', config); // Replace with your API endpoint
      const numberOfTokens = response.data.tokens;
      setNumberOfTokens(numberOfTokens);
    } catch (err) {
      console.log('Failed to fetch number of tokens. Please try again later.');
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Optionally, verify the token by sending it to the server
      // axios.get('https://api.pathvizor.com/verify-token', { headers: { Authorization: `Bearer ${token}` } })
      axios.get('https://api.pathvizor.com/verify-token', { headers: { Authorization: `Bearer ${token}` } })
        .then(() => {
          fetchUnlockedLeads();
          fetchNumberOfTokens();
          fetchIndustries();
        })
        .catch(() => {
          // If token is invalid, clear it from local storage
          localStorage.removeItem('token');
          window.location.href = '/login';
        });
    }
    else {
      window.location.href = '/login';
    }
  }, []);

  const [selectedFilters, setSelectedFilters] = useState(location.state?.filters || {});

      // Handle filter changes
      const handleFilterChange = (key, value) => {
        setSelectedFilters((prev) => ({
          ...prev,
          [key]: value,
        }));
      };

  const [search, setSearch] = useState(location.state?.searchFields || {})

  const fetchLeads = async (filters = selectedFilters, searchFields = search, currentPage = page, currentPageSize = pageSize) => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      if (!token) return;

      const params = {
        ...filters, ...searchFields,
        page: currentPage,
        pageSize: currentPageSize,
      };

            // Handle special cases for range filters
      if (filters.netWorthRange) {
        params.minNetWorth = filters.netWorthRange[0];
        params.maxNetWorth = filters.netWorthRange[1];
      }
      if (filters.ageRange) {
        params.minAge = filters.ageRange[0];
        params.maxAge = filters.ageRange[1];
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };

      const response = await axios.get('https://api.pathvizor.com/leads', config); // Replace with your API endpoint

      let totalStatesDict = {}
      let totalIndustriesDict = {}
      let statesArray = []
      let foreignCountriesArray = []
      let industriesArray = []

      const fetchedLeads = response.data.map((lead) => {

      //   if (!totalStatesDict[lead.PersonalAddressState]) {
      //     if (lead.PersonalAddressState != null) {
      //       totalStatesDict[lead.PersonalAddressState] = true
      //     }
      //   }
      //   if (!totalIndustriesDict[lead.PrimaryIndustry]) {
      //     if (lead.PrimaryIndustry != null) {
      //       totalIndustriesDict[lead.PrimaryIndustry] = true
      //     }
      //   }

        let compellingEvents = []
        if (lead.JobStartDate && new Date(lead.JobStartDate) > new Date("2024-01-01")) {
          compellingEvents.push("Job Change")
        }
        if (lead.trade_id) {
          compellingEvents.push("Sale of stock")
        }
        if (lead.founder_recent_fundraise) {
          compellingEvents.push("Recent Fundraising Round")
        }
        if (lead.has_inheritance) {
          compellingEvents.push("Inheritance")
        }
        if (lead.real_estate_doc_id) {
          compellingEvents.push("Recently Moved")
        }
        if (lead.performed_donation) {
          compellingEvents.push("Recent Donation")
        }
        return {
          id: lead.lead_id,
          name: lead.FirstName,
      //     gender: lead.gender === 'M' ? "Male" : "Female",
      //     age: lead.age,
      //     EducationLevel: lead.EducationLevel ? lead.EducationLevel : "Unknown",
          almaMater: lead.alma_mater ? lead.alma_mater : "Unknown",
          JobTitle: lead.JobTitle,
          netWorth: lead.net_worth,
      //     MobilePhone: lead.MobilePhone,
      //     Email: lead.Email,
      //     Linkedin: lead.Linkedin,
      //     PersonalAddressStreet: lead.PersonalAddressStreet ? lead.PersonalAddressStreet : "Unknown",
          PersonalAddressState: lead.PersonalAddressState ? lead.PersonalAddressState : "Unknown",
          PersonalAddressCity: lead.PersonalAddressCity ? lead.PersonalAddressCity : "Unknown",
      //     PersonalAddressZipCode: lead.PersonalAddressZipCode ? lead.PersonalAddressZipCode : "Unknown",
          PrimaryIndustry: lead.PrimaryIndustry ? lead.PrimaryIndustry : "Unknown",
      //     CompanyName: lead.CompanyName,
      //     Employees: lead.Employees,
      //     EmployeeRange: lead.EmployeeRange,
      //     RevenueRange: lead.RevenueRange,
      //     JobStartDate: new Date(lead.JobStartDate).toDateString(),
      //     Has401kData: lead.ein ? "True" : "False",
          compellingEvents: compellingEvents,
      //     cik: lead.cik,
      //     company_pbid: lead.company_pbid,
      //     has_inheritance: lead.has_inheritance,
      //     recent_move : lead.recent_move,
        };
      });
      setLeads(fetchedLeads);
      setTotalRowCount(fetchedLeads.length)
    } catch (err) {
      console.log('Failed to fetch leads. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads(location.state?.filters);
  }, [location.state]);

  const handleRefilter = () => {
    fetchLeads(selectedFilters);
  };

  const handleSearch = (category, value) => { 
    setSearch((prev) => ({
      ...prev,
      [category]: value,
    })
    );
  } 

  const evaluateInNetWorthRange = (netWorth, ranges) => {
    const [min, max] = ranges;
    if (max === 20000000) {
      if (netWorth >= min) {
        return true
      }
      return false
    }
    else {
      if (netWorth >= min && netWorth <= max) {
        return true
      }
      return false
    }
  };

  const evaluateInAgeRange = (age, ranges) => {
    const [min, max] = ranges;
    if (max === 100) {
      if (age >= min) {
        return true
      }
      return false
    }
    else {
      if (age >= min && age <= max) {
        return true
      } 
      return false
    };
  }

  const navigate = useNavigate();

   const sortedRows = useMemo(() => [...leads], [leads]);
  

    const handleViewDetails = (lead) => {
        navigate(`/lead/${lead.lead_id}`, { state: { lead } });
    };


  const [open, setOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedLead401k, setSelectedLead401k] = useState(null);
  const [insiderTrades, setInsiderTrades] = useState(null);
  const [realEstate, setRealEstate] = useState(null);
  const [realEstateTransactions, setRealEstateTransactions] = useState(null);
  const [companyDeals, setCompanyDeals] = useState(null);

  const [openSaveSearchModal, setOpenSaveSearchModal] = useState(false);
  const [openSaveListModal, setOpenSaveListModal] = useState(false);

  const [searchName, setSearchName] = useState('');
  const [searchDescription, setSearchDescription] = useState('');
  const [listName, setListName] = useState('');
  const [listDescription, setListDescription] = useState('');

  useEffect(() => {
    if (selectedLead) {
      axios.get(`https://api.pathvizor.com/leads/${selectedLead.id}/401k`) // Replace with your API endpoint
        .then((response) => {
          setSelectedLead401k(response.data);
        })
        .catch(() => {
          setSelectedLead401k(null);
        });
      axios.get(`https://api.pathvizor.com/insider_trades/${selectedLead.cik}`) // Replace with your API endpoint
        .then((response) => {
          setInsiderTrades(response.data.sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date)));
        })
        .catch(() => {
          setInsiderTrades(null);
        });
        axios.get(`https://api.pathvizor.com/real_estate/${selectedLead.id}`) // Replace with your API endpoint
        .then((response) => {
          setRealEstate(response.data.filter((property) => property.occupancy_type === 'OWN'));
        })
        .catch(() => {
          setRealEstate(null);
        });
        axios.get(`https://api.pathvizor.com/leads/${selectedLead.id}/real_estate_transactions`) // Replace with your API endpoint
        .then((response) => {
          setRealEstateTransactions(response.data);
        })
        .catch(() => {
          setRealEstateTransactions(null);
        });
        axios.get(`https://api.pathvizor.com/business_deals/${selectedLead.company_pbid}`) // Replace with your API endpoint
        .then((response) => {
          setCompanyDeals(response.data);
        })
        .catch(() => {
          setCompanyDeals(null);
        });
    }
  }, [selectedLead]);


  const handleOpenModal = (lead) => {
    setSelectedLead(lead);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedLead(null);
  };

  const exportFilteredLeads = () => {
    if (!leads.length) {
      alert("No data to export!");
      return;
    }

    const startIndex = page * pageSize;
    const endIndex = startIndex + pageSize;
    const visibleRows = leads.slice(startIndex, endIndex);
  
    const csvData = Papa.unparse(
      visibleRows.map(({ id, name, EducationLevel, PersonalAddressState, PrimaryIndustry, JobTitle }) => ({
        ID: id,
        Name: name,
        Education: EducationLevel,
        State: PersonalAddressState,
        Industry: PrimaryIndustry,
        Job: JobTitle,
      }))
    );
  
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(csvBlob, "filtered_leads.csv");
  };

  const columns = [
    {
      field: 'select',
      headerName: '',
      renderCell: (params) => (
        <Checkbox
          checked={!!checkedRows[params.row.id]}
          onChange={() => handleCheck(params.row.id)}
          disabled={unlockedLeads.includes(params.row.id)}
        />
      ),
    },
    { field: 'name', headerName: 'Name', width: 200, 
      // renderCell: (params) => (
      //   <Button
      //     variant="text"
      //     color="primary"
      //     onClick={() => handleOpenModal(params.row)} // Pass the entire lead to the handler
      //   >
      //     {params.value}
      //   </Button>
      // ),
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'PersonalAddressState', headerName: 'State', width: 150, 
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'PersonalAddressCity', headerName: 'City', width: 150, 
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'PrimaryIndustry', headerName: 'Industry', width: 150,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'JobTitle', headerName: 'Occupation', width: 200,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'almaMater', headerName: 'Education', width: 150,
      sortComparator: (v1, v2) => v1.localeCompare(v2),
    },
    { field: 'netWorth', headerName: 'Estimated Net Worth', width: 150,
      renderCell: (params) => (
        <div>
        {`$${params.value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </div>
      ),
      sortComparator: (v1, v2) => v1 - v2,
    },
    { field: 'compellingEvents', headerName: 'Compelling Events', width: 150,
      sortComparator: (v1, v2) => v1.length - v2.length,
    },
  ]

  const handleUnlockLeads = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      await axios.post('https://api.pathvizor.com/unlock_leads',
        {
          // list_name: listName,
          // description: listDescription,
          leadIds: Object.keys(checkedRows).filter((id) => checkedRows[id]),
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        });
      // re-fetch to show newly created
    } catch (error) {
      if (error.response === 400) {
        console.error('Error creating new lead list:', error.response.data);
        setFailedUnlockModal(true);
      }
    }
    setOpenSaveListModal(false);
    setSuccessUnlockModal(true);
    setCheckedRows([]);
  };

  const handleCreateSearch = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      await axios.post('https://api.pathvizor.com/saved_searches',
        {
          search_name: searchName,
          description: searchDescription,
          param_name: search.name,
          param_money_events: selectedFilters.compellingEvents,
          param_locations: selectedFilters.location,
          param_gender: selectedFilters.gender,
          param_age_range: selectedFilters.ageRange,
          param_networth_range: selectedFilters.netWorthRange,
          param_education: selectedFilters.education,
          param_industry: selectedFilters.industry,
          param_industry_level: [],
          param_job_title: search.job_title,
          param_alma_mater: search.alma_mater
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        });
      // re-fetch to show newly created
    } catch (error) {
      console.error('Error creating new saved search:', error);
    }
    setOpenSaveSearchModal(false);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh'}}> 

      <Drawer
        sx={{
          height: 'calc(100vh - 64px)', 
          top: '64px',
          position: 'fixed',
          width: showFilters ? (filtersExpanded ? 450 : 300) : 0,
          flexShrink: 0,
          transition: 'width 0.3s ease',
          '& .MuiDrawer-paper': {
            width: showFilters ? (filtersExpanded ? 450 : 300) : 0,
            boxSizing: 'border-box',
            backgroundColor: '#f9fafb',
            borderRight: '1px solid #e0e0e0',
            padding: 2,
            transition: 'width 0.3s ease',
            height: 'calc(100vh - 64px)', 
            top: '64px',
            position: 'fixed',
          },
        }}
        variant="permanent"
        anchor="left"
      >

        <List>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1, mb: 1 }}>
    <>
      <Button size="small" onClick={() => setSelectedFilters({
              education: [],
              location: [],
              industry: [],
              compellingEvents: [],
              gender: [],
              netWorthRange: [],
              ageRange: [],
      })}>Clear All</Button>
      <Button size="small" onClick={() => setFiltersExpanded(!filtersExpanded)}>
        {filtersExpanded ? 'Collapse' : 'Expand'}
      </Button>
    </>
</Box>

          <Divider sx={{ marginBottom: 2 }} />

          <Button onClick={() => setOpenSaveSearchModal(true)}> Save Profile</Button>
          <Button onClick={() => fetchLeads()}> Update Search </Button>
  
          <ListItem>
            <TextField
              label="Search Name"
              variant="outlined"
              fullWidth
              value={search.name}
              onChange={(e) => handleSearch('name', e.target.value)}
              sx={{ marginBottom: 2 }}
            />
          </ListItem>
          <ListItem>
            <LeadListFilters
              statesOptions={Object.keys(locationsOptions)}
              industriesOptions={totalIndustries} 
              selectedFilters={selectedFilters} 
              setSelectedFilters={setSelectedFilters}
            />
          </ListItem>
  
          {/* Occupation Filter */}
          <ListItem>
          <TextField
              label="Search Job Title"
              variant="outlined"
              fullWidth
              value={search.job_title}
              onChange={(e) => handleSearch('job_title', e.target.value)}
              sx={{ marginBottom: 2 }}
            />
          </ListItem>

          {/* Alma mater */}
          <ListItem>
          <TextField
              label="Alma mater"
              variant="outlined"
              fullWidth
              value={search.alma_mater}
              onChange={(e) => handleSearch('alma_mater', e.target.value)}
              sx={{ marginBottom: 2 }}
            />
          </ListItem>
          
        </List>
      </Drawer>
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          marginLeft: showFilters ? (filtersExpanded ? '450px' : '300px') : '0', // Adjust content margin based on drawer width
          marginTop: '64px', // Offset the content below the header
          transition: 'margin 0.3s ease',
        }}
      >
        {
        loading ? 
        (<CircularProgress sx={{ width: '80%',
          height: '100%', }}/>) :
        (
          <Box sx={{ flexGrow: 1, padding: 3, transition: 'margin 0.3s ease' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between', // Space between the two items
            alignItems: 'center', // Vertically align items
            marginBottom: 3,
          }}
        >
          <Typography variant="h4" color="primary" gutterBottom>
            {leads.length} Results
          </Typography>

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h6" fontWeight="bold">
              Lead Unlock Tokens
            </Typography>
            <Typography variant="h4" color="primary">
              {numberOfTokens}
            </Typography>
          </Box>
        </Box>
          
          {Object.entries(selectedFilters).some(([_, values]) => values.length > 0) && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mb: 2,
            }}
          >
            {Object.entries(selectedFilters).map(([key, values]) =>
            {
              if (key === 'netWorthRange' || key === 'ageRange') {
                return null
              }
              else {
                values.map((value) => (
                  <Chip
                    key={`${key}-${value}`}
                    label={value}
                    onDelete={() => {
                      const newValues = selectedFilters[key].filter((v) => v !== value);
                      setSelectedFilters((prev) => ({
                        ...prev,
                        [key]: newValues,
                      }));
                    }}
                    color="primary"
                    variant="outlined"
                  />
                ))
              }
            }
            )}
          </Box>
        )}



        <Button variant="contained" color="primary" onClick={() => setOpenSaveListModal(true)} disabled={Object.keys(checkedRows).length === 0}>
          Unlock Selected Leads
        </Button>
        <DataGrid 
          rows={sortedRows} 
          columns={columns}
          pagination
          paginationMode="client"
          paginationModel={{ page: page, pageSize }}
          onPaginationModelChange={(model) => {
            setPage(model.page); // Convert 0-based index to 1-based index
            setPageSize(model.pageSize)
            // fetchLeads(selectedFilters, search, model.page, pageSize); // Fetch data for the new page
          }}
          // initialState={{
          //   pagination: { paginationModel: { page: 1, pageSize: 50 } },
          // }} 
          rowCount={totalRowCount}
          pageSizeOptions={[10, 25, 100]} />
          <Button variant="contained" color="primary" onClick={exportFilteredLeads}>
          Export Filtered Leads
        </Button>
        </Box>
        )
        }
      <Modal 
        open={successUnlockModal}
        onClose={() => setSuccessUnlockModal(false)}
        closeAfterTransition
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2>Success!</h2>
          <h5>You have successfully unlocked {Object.keys(checkedRows).length} {Object.keys(checkedRows).length === 1 ? "lead" : "leads"}.</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setSuccessUnlockModal(false);
                  window.location.href = '/saved-leads';
                }}
              >
                View Unlocked Leads
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setSuccessUnlockModal(false);
                fetchUnlockedLeads();
                fetchNumberOfTokens();
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={failedUnlockModal}
        onClose={() => setFailedUnlockModal(false)}
        closeAfterTransition
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2>Error</h2>
          <h5>There was an error unlocking the leads. Please try again later.</h5>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setFailedUnlockModal(false)}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openSaveListModal}
        onClose={() => setOpenSaveListModal(false)}
        closeAfterTransition
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2>Are you sure you would like to spend {Object.keys(checkedRows).length} {Object.keys(checkedRows).length === 1 ? "token" : "tokens"} to unlock these leads?</h2>

          <h5>You have {numberOfTokens} tokens</h5>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleUnlockLeads}
            >
              Confirm
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpenSaveListModal(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openSaveSearchModal}
        onClose={() => setOpenSaveSearchModal(false)}
        closeAfterTransition
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
          }}
        >
          <h2>Save Search Profile</h2>
          <TextField
            fullWidth
            label="Search Name"
            variant="outlined"
            sx={{ mb: 2 }}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Description"
            variant="outlined"
            sx={{ mb: 2 }}
            value={searchDescription}
            onChange={(e) => setSearchDescription(e.target.value)}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateSearch}
            >
              Save Profile
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setOpenSaveSearchModal(false)}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={open}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          height: '100%',
        }}
      >
      <Slide direction="left" in={open} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '80%',
            height: '100%',
            bgcolor: 'background.paper',
            padding: 4,
            borderRadius: 2,
            boxShadow: 24,
            overflowY: 'auto',
          }}
        >
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          {selectedLead?.name || 'N/A'}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ width: '50%' }}>
            <Typography variant="body1">
              <strong>Company:</strong> {selectedLead?.CompanyName || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Job Title:</strong> {selectedLead?.JobTitle || 'N/A'}
            </Typography>
            <Typography variant="body1">
              {
                selectedLead?.almaMater ? (
                  <>
                    <strong>Alma Mater:</strong> {selectedLead?.almaMater}
                  </>
                ) : (
                  <>
                  <strong>Education:</strong> {selectedLead?.EducationLevel || 'N/A'}
                  </>
                )
              }
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Phone:</strong> {selectedLead?.MobilePhone || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Email:</strong> {selectedLead?.Email || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>LinkedIn:</strong>{' '}
              <a
                href={selectedLead?.Linkedin || '#'}
                target="_blank"
                rel="noopener noreferrer"
              >
                {selectedLead?.Linkedin || 'N/A'}
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

      <Box sx={{ marginBottom: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ width: '50%' }}>
            <Typography variant="body1">
            <strong>Estimated Net Worth:</strong> {`$${selectedLead?.netWorth}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Inferred Income:</strong> $500,000
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

      {
        (selectedLead && realEstate && realEstate.length > 0) ? (
          <Box sx={{ marginBottom: 4 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Real Estate
          </Typography>
          {realEstate.map((property) => (
          <Grid container spacing={2}>
          <Grid item xs={6} sx={{ width: '50%' }}>
            <Typography variant="body1">
              {property?.street_1 || 'N/A'}
            </Typography>
            <Typography variant="body1">
              {property?.city || 'N/A'},{' '}
              {property?.state || 'N/A'}{' '}
              {property?.postal_code || 'N/A'}

            </Typography>
            <Typography variant="body1">
              USA
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Estimated Price:</strong> {`$${property.purchase_price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </Typography>
            <Typography variant="body1">
              <strong>Purchase Date:</strong> { new Date(property?.start_date).toDateString() || 'N/A'}
            </Typography>
          </Grid>
        </Grid>
          ))}

        </Box>
        ) 
        :
        <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Address
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ width: '50%' }}>
            <Typography variant="body1">
              {selectedLead?.PersonalAddressStreet || 'N/A'}
            </Typography>
            <Typography variant="body1">
              {selectedLead?.PersonalAddressCity || 'N/A'},{' '}
              {selectedLead?.PersonalAddressState || 'N/A'}{' '}
              {selectedLead?.PersonalAddressZipCode || 'N/A'}

            </Typography>
            <Typography variant="body1">
              USA
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Home Price:</strong> {selectedLead?.HomePrice || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Interest Rate:</strong> {selectedLead?.InterestRate || 'N/A'}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      }



      <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Company Data
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sx={{ width: '50%' }}>
            <Typography variant="body1">
              <strong>Company Name:</strong> {selectedLead?.CompanyName || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Industry:</strong> {selectedLead?.PrimaryIndustry || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Number of Employees:</strong> {selectedLead?.Employees ? selectedLead?.Employees : selectedLead?.EmployeeRange ? selectedLead?.EmployeeRange : 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>Revenue:</strong> {selectedLead?.RevenueRange || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Employee Since:</strong> {selectedLead?.JobStartDate || 'N/A'}
            </Typography>
            <Typography variant="body1">
              <strong>401k Plan:</strong> {selectedLead?.Has401kData || 'N/A'}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

      {
        (realEstateTransactions?.transactions?.filter((transaction) => transaction.doc_type === 'TODD').length > 0 ) ? (
          <Box sx={{ marginBottom: 4 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Real Estate Recently Inherited
            </Typography>
            <DataGrid 
              rows={realEstateTransactions.transactions.filter((property) => property.doc_type === 'TODD')} 
              columns={[
                { field: 'doc_date' , headerName: 'Date Inherited', width: 200,
                  renderCell: (params) => (
                    <div>
                      {new Date(params.value).toDateString()}
                    </div>
                  )
                },
                { field: 'street_1', headerName: 'Street Address', width: 200,},
                { field: 'state', headerName: 'State', width: 200,},
                { field: 'postal_code', headerName: 'Zip Code', width: 200,},
                { field: 'country', headerName: 'Country', width: 200,},
                { field: 'year_built', headerName: 'Year Built', width: 200,},
                { field: 'assessment_total', headerName: 'Estimated Value', width: 200, renderCell: (params) => (
                  <div>
                    $ {(Math.round(params.value / 45) * 100).toLocaleString()}
                  </div>
                )},
              ]}   
              getRowId={(row) =>  row.document_id}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }} 
              pageSizeOptions={[10, 25, 100]} />
          </Box>

        ) 
        : <></>
      }

{
        (realEstateTransactions?.transactions?.filter((property => ['DEED', 'RPTT', 'RETT'].includes(property.doc_type))).length > 0) ? (
          <Box sx={{ marginBottom: 4 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Recent Real Estate Transactions
            </Typography>
            <DataGrid 
              rows={realEstateTransactions.transactions.filter((property => ['DEED', 'RPTT', 'RETT'].includes(property.doc_type)))} 
              columns={[
                { field: 'doc_date' , headerName: 'Date Inherited', width: 200,
                  renderCell: (params) => (
                    <div>
                      {new Date(params.value).toDateString()}
                    </div>
                  )
                },
                { field: 'street_1', headerName: 'Street Address', width: 200,},
                { field: 'state', headerName: 'State', width: 200,},
                { field: 'postal_code', headerName: 'Zip Code', width: 200,},
                { field: 'country', headerName: 'Country', width: 200,},
                { field: 'year_built', headerName: 'Year Built', width: 200,},
                { field: 'assessment_total', headerName: 'Estimated Value', width: 200, renderCell: (params) => (
                  <div>
                    $ {(Math.round(params.value / 45) * 100).toLocaleString()}
                  </div>
                )},
              ]}   
              getRowId={(row) =>  row.document_id}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }} 
              pageSizeOptions={[10, 25, 100]} />
          </Box>

        ) 
        : <></>
      }

      {
        (selectedLead?.cik && insiderTrades) ? (
          <Box sx={{ marginBottom: 4 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Insider Trades
            </Typography>
            <DataGrid 
              rows={insiderTrades} 
              columns={[
                { field: 'Ticker' , headerName: 'Ticker', width: 200,
                },
                { field: 'CompanyName', headerName: 'Security Name', width: 200,},
                { field: 'acquired_disposed', headerName: 'Transaction Type', width: 200, renderCell: (params) => (
                  <div>
                    {params.value === 'A' ? 'Buy' : 'Sell'}
                  </div>
                )},
                { field: 'transaction_date', headerName: 'Transaction Date', width: 200, renderCell: (params) => (
                  <div>
                    {new Date(params.value).toDateString()}
                  </div>
                )},
                { field: 'transaction_shares', headerName: 'Transaction Shares', width: 200, 
                },
                { field: 'transaction_price', headerName: 'Transaction Price', width: 200, 
                },
                { field: 'shares_owned_following', headerName: 'Shares Owned Following', width: 200, 
                },
                { field: 'trade_type', headerName: 'Trade Type', width: 200, 
                },
                { field: 'transaction_code', headerName: 'Transaction Code', width: 200,
                },
                { field: 'transaction_form_type', headerName: 'Transaction Form Type', width: 200,
                },
                { field: 'equity_swap_involved', headerName: 'Equity Swap Involved', width: 200, renderCell: (params) => (
                  <div>
                    {params.value ? 'Yes' : 'No'}
                  </div>
                )},
                { field: 'direct_or_indirect', headerName: 'Ownership type', width: 200, renderCell: (params) => (
                  <div>
                    {params.value === 'D' ? 'Direct' : 'Indirect'}
                  </div>
                )},
              ]}   
              getRowId={(row) =>  row.trade_id}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }} 
              pageSizeOptions={[10, 25, 100]} />
          </Box>

        ) 
        : <></>
      }
      {
        (selectedLead?.company_pbid && companyDeals && companyDeals.length > 0) ? (
          <Box sx={{ marginBottom: 4 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Business Development Data
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ width: '50%' }}>
              <Typography variant="body1">
                <strong>Company Name:</strong> {companyDeals[0].CompanyName || 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Industry:</strong> {companyDeals[0].PrimaryIndustry || 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Founded:</strong> {companyDeals[0].FoundedYear || 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Company Website:</strong> {companyDeals[0].Website || 'N/A'}
              </Typography>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {companyDeals[0].HQPhone || 'N/A'}
              </Typography>
            </Grid>

          </Grid>
          <DataGrid 
              rows={companyDeals} 
              columns={[
                { field: 'deal_type' , headerName: 'Deal Type', width: 200,
                },
                { field: 'deal_date', headerName: 'Deal Date', width: 200, renderCell: (params) => (
                  <div>
                    {new Date(params.value).toDateString()}
                  </div>
                )},
                { field: 'deal_amount', headerName: 'Deal Amount', width: 200, renderCell: (params) => (
                  <div>
                    $ {params.value}
                  </div>
                )},
                { field: 'post_valuation', headerName: 'Post Valuation', width: 200, renderCell: (params) => (
                  <div>
                    $ {params.value}
                  </div>
                )},
                { field: 'revenue', headerName: 'Revenue', width: 200, renderCell: (params) => (
                  <div>
                    $ {params.value}
                  </div>
                )}
              ]}   
              getRowId={(row) =>  row.event_pbid}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }} 
              pageSizeOptions={[10, 25, 100]} />
        </Box>
        )
        :<></>
      }
      {
        selectedLead && selectedLead401k ? (
          <Box sx={{ marginBottom: 4 }}>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            401k Details
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ width: '50%' }}>
              <Typography variant="body1">
                <strong>Plan Name:</strong> SAP America, Inc. 401(k) Plan
              </Typography>
              <Typography variant="body1">
              <strong>Assets:</strong> $7,535,277,617
              </Typography>
  
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">
                <strong>Total Number of Options:</strong> 21
              </Typography>
  
            </Grid>
          </Grid>
          <br></br>
          <DataGrid 
          rows={[
            {
              id: "VFTC Retirement Savings Trust III",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$307,314,841"
            },
            {
              id: "Vanguard Institutional 500 IDX Trust",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$1,279,758,592"
            },
            {
              id: "Vanguard Institutional TTL Bond IDX Trust",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$386,529,608"
            },
            {
              id: "VFTC INST TTL INT ST Market IND Trust",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$441,030,467"
            },
            {
              id: "VFTC INST EXT Market Index Trust",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$364,800,318"
            },
            {
              id: "VFTC Target Retirement INCO Trust PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$38,556,669"
            },
            {
              id: "VFTC Target Retirement 2020 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$56,962,190"
            },
            {
              id: "VFTC Target Retirement 2025 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$152,775,237"
            },
            {
              id: "VFTC Target Retirement 2030 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$227,730,070"
            },
            {
              id: "VFTC Target Retirement 2035 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$268,400,546"
            },
            {
              id: "VFTC Target Retirement 2040 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$220,930,173"
            },
            {
              id: "VFTC Target Retirement 2045 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$169,356,375"
            },
            {
              id: "VFTC Target Retirement 2050 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$134,113,172"
            },
            {
              id: "VFTC Target Retirement 2055 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$95,000,050"
            },
            {
              id: "VFTC Target Retirement 2060 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$51,569,517"
            },
            {
              id: "VFTC Target Retirement 2065 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$17,191,079"
            },
            {
              id: "VFTC Target Retirement 2070 TRST PL",
              fundEntity: "Vanguard Fiduciary Trust Company",
              dollarValue: "$3,563,116"
            },
            {
              id: "T. Rowe Price Blue Chip Growth Trust",
              fundEntity: "T. Rowe Price Trust Company",
              dollarValue: "$0"
            },
            {
              id: "Allspring Special Small Cap Value E",
              fundEntity: "Allsring Global Investments",
              dollarValue: "$19,018,208"
            },
            {
              id: "Blackrock Midcap Growth Equity Y",
              fundEntity: "Blackrock Institutional Trust Co",
              dollarValue: "$37,614,340"
            },
            {
              id: "JPMCB Large Cap Growth Fund; CF-A C",
              fundEntity: "JP Morgan Asset Company",
              dollarValue: "$358,074,868"
            },
          ]} 
          columns={[
            { field: 'id', headerName: 'Fund Name', width: 350, 
            },
            { field: 'fundEntity', headerName: 'Fund Entity', width: 350, 
            },
            { field: 'dollarValue', headerName: 'Fund Size', width: 350,
            },
          ]}   
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }} 
          pageSizeOptions={[10, 25, 100]} />
          <br></br>
                      <Typography variant="body1">
                <a
                  href={"https://efast2-filings-public.s3.amazonaws.com/prd/2024/06/21/20240621154315NAL0001918451001.pdf"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                <strong>PDF Link</strong> 
                </a>
              </Typography>
        </Box>
        )
        : <></>
      }

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', marginTop: 4 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleViewDetails(selectedLead)}
        >
          View Full Details
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleCloseModal}>
          Close
        </Button>
      </Box>    

        </Box>
      </Slide>
      </Modal>
      </Box>

    </Box>
  );
}



export default HomeTable;
